import { Logtail } from '@logtail/browser';
import { ILogtailLog } from '@logtail/types';

import store from 'redux/store';
import {
  getUserEmail,
  getUserId,
  getUserRole,
  getUserSessionId,
} from 'redux/user';

import { version } from '../../package.json';

const env = import.meta.env.REACT_APP_DEPLOY_ENV ?? 'unknown';

const logtailClient = new Logtail('Wve8XVnwE4sA1A3a7TuUTBCx');

logtailClient.use(async (log: ILogtailLog): Promise<ILogtailLog> => {
  const state = store.getState();
  const userEmail = getUserEmail(state);

  return {
    ...log,
    env: env.toUpperCase(),
    version,
    sessionId: getUserSessionId(state),
    user: {
      id: getUserId(state),
      ...(userEmail && { email: userEmail }),
      role: getUserRole(state),
    },
  };
});

export default function useLogtail(): Logtail {
  return logtailClient;
}
